import { Constant, Headers } from "../apiConstants";

const DineInPaymentAPI = async (
  outletId,
  originalAmount,
  payableAmount,
  walletReward,
  couponCode,
  isPromo,
  offerID,
  promocodeID
) => {
  const endpoint = Constant.DINE_IN_PAYMENT;
  const BaseUrl = Constant.BASE_URL;
  try {
    const response = await fetch(BaseUrl + "/" + endpoint, {
      method: "post",
      headers: Headers,
      body: JSON.stringify({
        outletId: outletId,
        walletAmt: walletReward,
        payableAmount: payableAmount,
        originalAmt: originalAmount,
        emailId: "",
        couponCode: couponCode,
        promoType: isPromo,
        offerId: offerID,
        promocodeId: promocodeID,
      }),
    });
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default DineInPaymentAPI;
